import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[cappusPreventKeyDown]',
})
export class PreventKeyDownDirective {
  @HostListener('keydown', ['$event'])
  onClick($event: Event): boolean {
    $event.preventDefault();
    $event.stopPropagation();
    return false;
  }
}
